// survey-jobs API 응답에서 드롭다운용 옵션 추출 헬퍼

// 전체 ITSQF 직무 드롭다운 옵션 (서비스 패키지 / 견적서 행)
// 라벨: [조사용직무] ITSQF직무
// rates 도 함께 들고 다녀서 ITSQF 선택 후 기술등급 옵션 즉시 추출 가능
export function itsqfJobOptions(surveyJobs) {
  if (!Array.isArray(surveyJobs)) return [];
  return surveyJobs.flatMap(sj => (sj.itsqf_jobs || []).map(j => ({
    itsqf_job_id: j.id,
    itsqf_job: j.itsqf_job,
    job_definition: j.job_definition || '',
    survey_job_id: sj.id,
    survey_job: sj.survey_job,
    job_category: sj.job_category,
    rates: sj.rates || [],
    label: `[${sj.survey_job}] ${j.itsqf_job}`,
  })));
}

// ITSQF 옵션에서 기술등급 옵션 추출
export function skillLevelOptionsFor(itsqfOption) {
  if (!itsqfOption) return [];
  return (itsqfOption.rates || []).map(r => ({
    skill_level: r.skill_level,
    monthly_rate: r.monthly_rate,
    label: `${r.skill_level} - ₩${Number(r.monthly_rate||0).toLocaleString()}`,
  }));
}

// 옵션 배열에서 itsqf_job_id 로 찾기
export function findItsqfOption(options, itsqfJobId) {
  if (itsqfJobId == null) return null;
  return options.find(o => o.itsqf_job_id === itsqfJobId) || null;
}

// === 조사용직무 우선 선택 흐름용 헬퍼 ===

// 조사용직무 옵션 (라벨은 이름만)
export function surveyJobBriefOptions(surveyJobs) {
  if (!Array.isArray(surveyJobs)) return [];
  return surveyJobs.map(sj => ({
    survey_job_id: sj.id,
    survey_job: sj.survey_job,
    job_category: sj.job_category,
    label: sj.survey_job,
    itsqf_jobs: sj.itsqf_jobs || [],
    rates: sj.rates || [],
  }));
}

// 선택된 조사용직무 옵션에서 ITSQF 직무 옵션 추출 (라벨은 이름만)
export function itsqfOptionsForSurvey(surveyOpt) {
  if (!surveyOpt) return [];
  return (surveyOpt.itsqf_jobs || []).map(j => ({
    itsqf_job_id: j.id,
    itsqf_job: j.itsqf_job,
    job_definition: j.job_definition || '',
    label: j.itsqf_job,
  }));
}

// 선택된 조사용직무 옵션에서 기술등급 옵션 (라벨은 이름만)
export function skillBriefOptionsForSurvey(surveyOpt) {
  if (!surveyOpt) return [];
  return (surveyOpt.rates || []).map(r => ({
    skill_level: r.skill_level,
    monthly_rate: r.monthly_rate,
    label: r.skill_level,
  }));
}

// 옵션 배열에서 survey_job_id 로 찾기
export function findSurveyOption(options, surveyJobId) {
  if (surveyJobId == null) return null;
  return options.find(o => o.survey_job_id === surveyJobId) || null;
}
